'use client';

import { PropsWithChildren, useEffect } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { useLayoutStore } from '@entities/user';
import { ContactUsModal } from '@features/user/contactUs';
import { AlumniContactUsModal } from '@features/user/alumniContactUs';
import { useBreakpoints } from '@shared/hooks';

const PageProvider = (props: PropsWithChildren) => {
  const { children } = props;

  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const breakpoint = useLayoutStore((state) => state.breakpoint);
  const setBreakpoint = useLayoutStore((state) => state.setBreakpoint);

  const [, newBreakpoint] = useBreakpoints(undefined, 'window');

  useEffect(() => {
    setBreakpoint(newBreakpoint);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newBreakpoint]);

  if (!breakpoint) {
    return null;
  }

  return (
    <>
      <ContactUsModal
        isOpen={searchParams.get('contact-us') === 'true'}
        close={() => {
          const newParams = new URLSearchParams(searchParams);
          newParams.delete('contact-us');
          router.replace(`${pathname}${newParams.size ? `?${newParams}` : ''}`);
        }}
      />

      <AlumniContactUsModal
        isOpen={searchParams.get('alumni-contact') === 'true'}
        close={() => {
          const newParams = new URLSearchParams(searchParams);
          newParams.delete('alumni-contact');
          router.replace(`${pathname}${newParams.size ? `?${newParams}` : ''}`);
        }}
      />

      {children}
    </>
  );
};

export default PageProvider;
